<div class="px-3 mt-2">
  <form [formGroup]="mailMergeForm">
    Draw an area on the map or select a property to start your search.
    <div class="radio-toolbar d-flex justify-content-center mt-3 pb-3">
      <div>
        <input type="radio" formControlName="selectionMethod" id="radioArea" value="area" (click)="mailLabelDraw()">
        <label for="radioArea" class="left">Draw<br /><i class="far fa-draw-square"></i></label>
      </div>
      <div>
        <input type="radio" formControlName="selectionMethod" id="radioProperty" value="property"
          (click)="mailLabelSelect()">
        <label for="radioProperty" class="right">Select<br /><i class="far fa-mouse-pointer"></i></label>
      </div>
    </div>
    <div class="d-flex justify-content-center pb-3 btn-clear-wrapper">
      <button type="button" class="btn btn-primary btn-clear-map btn-sm" (click)="mapClear()"><i
      class="far fa-eraser"></i>
    Clear</button>
  </div>
  <h3 class="mt-3">Search Radius</h3>
  <div class="mail-buffer-slider">
    <ngx-slider formControlName="mailSliderControl" [options]="sliderOptions"
      (valueChange)="bufferSliderChange($event)">
    </ngx-slider>
  </div>
  <div class="form-inline mt-2">
    <label for="mailBuffer" class="col-3 pl-0 justify-content-start">Within </label>
    <div class="col-6 p-0">
      <div class="input-group">
        <input formControlName="selectionBuffer" id="mailBuffer" type="number" class="form-control"
          (change)="bufferChange($event)">
        <span class="input-group-text">m</span>
      </div>
    </div>
  </div>
  @if (showOptions) {
    <div>
      <div class="form-group mt-2">
        <h3>Options</h3>
        <ng-container formArrayName="recipients">
          @for (c of formControls(); track c; let i = $index) {
            <div class="form-check">
              <input class="form-check-input" type="checkbox" (change)="onCheckChanged($event)" [formControlName]="i"
                [id]="recipientsValues[i].id">
              <label class="form-check-label" [for]="recipientsValues[i].id">
                Include {{recipientsValues[i].name}}
              </label>
            </div>
          }
        </ng-container>
        <div class="form-check offset-sm-1">
          <input class="form-check-input" type="checkbox" value="true" id="ownerName" formControlName="ownerName"
            (change)="onCheckChanged($event)">
          <label class="form-check-label" for="ownerName">
            Personalize with Owner Name (if applicable)
          </label>
        </div>
        <div class="form-check mt-2">
          <input class="form-check-input" type="checkbox" value="true" id="combineOwners"
            formControlName="combineOwners" (change)="onCheckChanged($event)">
          <label class="form-check-label" for="combineOwners">
            Combine Owners at Same Address
          </label>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-link pl-0 btn-mail" (click)="openModal(modalMailMergeHowto)"><i
        class="fal fa-question-circle"></i> Mail
        Merge
      instructions</button>
      <button type="button" class="btn btn-primary btn-mail-download" (click)="downloadCSV()"
        [disabled]="!mailMergeForm.valid"><i class="fal fa-download"></i>
      Download</button>
    </div>
    @if (mailMergeState.resultCount > 0) {
      <div>{{mailMergeState.resultCount}} records</div>
    }
  </div>
}
</form>
</div>

<!-- mail merge instructions -->
<ng-template #modalMailMergeHowto let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mail Merge in Microsoft Word</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Starting from scratch:<br />
      <a href="https://support.microsoft.com/en-us/office/print-labels-for-your-mailing-list-276a2cd1-74d2-43d0-ab5a-b90460358ad5"
        target="_blank">Print labels for your mailing list <i class="fal fa-external-link"></i></a>
      </p>
      <p>Using a template:</p>
      <ol>
        <li>Open up Microsoft Word and start a new document. Choose <strong>"New"</strong> and select the templates folder
        <strong>"Templates2016"</strong>
        then select the folder <strong>"Geotools"</strong> and choose the template <strong>"Mail Labels - Avery
      5160"</strong><br />
      <img src="/images/mailmerge/step1.png" class="auto">
    </li>
    <li>Next you will be prompted to specify the location of your mailing list which will likely be the
      <strong>"Downloads"</strong>
      folder (This PC > Downloads)<br />
      <img src="/images/mailmerge/step2.png" class="auto">
    </li>
    <li>You can select <strong>"Preview Results"</strong> to verify results or go straight to step 4<br /><img
  src="/images/mailmerge/step3.png"></li>
  <li>Lastly, click on <strong>"Finish & Merge"</strong>, then either select <strong>"Edit Individual
Documents"</strong> before printing or select
<strong>"Print Documents"</strong> to print right away<br /><img src="/images/mailmerge/step4.png">
</li>
</ol>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="close()" ngbAutofocus>Close</button>
</div>
</ng-template>

<!-- combine owners -->
<ng-template #modalCombineOwners let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Combining Owners</h4>
  </div>
  <div class="modal-body">
    For statutory mail out campaigns, please note that combining owners on a single envelope may not meet DNV
    requirements. If unsure, please confirm with your supervisor.
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()" ngbAutofocus>Close</button>
  </div>
</ng-template>